import { textNodeToJsxPrinter, htmlNodeToJsxPrinter, generateJsxKey } from '@utils/ast';
import { glossaryWord, counter } from './printer.glossary-word.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const printPrintableGlossaryWord = (node, context) => {
  return /*#__PURE__*/jsxs("span", {
    className: glossaryWord,
    children: [context.printChildren(node.children, {
      html: htmlNodeToJsxPrinter,
      text: textNodeToJsxPrinter
    }), /*#__PURE__*/jsx("sup", {
      className: counter
    })]
  }, generateJsxKey(context));
};

export { printPrintableGlossaryWord };
//# sourceMappingURL=printer.glossary-word.js.map
